import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const studentProfileApi = createApi({
  reducerPath: 'studentProfileApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getStudentProfile: builder.query({
      query: () => ({
        url: `/WebAuth/GetStudentProfile`,
        method: 'GET',
      }),
    }),
    updateStudentProfile: builder.mutation({
      query: (formData) => ({
        url: `/WebAuth/UpdateProfile`,
        method: 'POST',
        body: formData,
      }),
    }),
    updatePassword: builder.mutation({
      query: (body) => ({
        url: `/WebAuth/UpdatePassword`,
        method: 'POST',
        body
      }),
    }),
    getBillingDetails: builder.query({
      query: ({pageNumber, pageSize, search}) => ({
        url: `/WebSessionBooking/GetAllBillingDetails`,
        method: 'GET',
        params: {pageNumber, pageSize, search}
      }),
    }),
  }),
});

export const {
  useGetStudentProfileQuery,
  useUpdateStudentProfileMutation,
  useUpdatePasswordMutation,
  useGetBillingDetailsQuery,
  useLazyGetBillingDetailsQuery
} = studentProfileApi;
